import React from 'react'
import { withStyles } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { fieldToTextField } from 'formik-material-ui'
import MetricaGreenTextField from './MetricaGreenTextField'

const CssAutocomplete = withStyles({
  listbox: {
    maxHeight: 207,
    scrollbarWidth: 'none',
    overflowY: 'overlay',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 0
    }
  },
  paper: {
    zIndex: 9999,
    background: '#fff'
  },
  popupIndicator: {
    color: 'rgba(255, 255, 255, 0.6)'
  }
})(Autocomplete)

const AutocompleteField = ({ textFieldProps, ...props }) => {
  const {
    form: { setFieldTouched, setFieldValue }
  } = props
  const { error, helperText, ...field } = fieldToTextField(props)
  const { name } = field

  return (
    <CssAutocomplete
      {...props}
      {...field}
      disableClearable
      onChange={(_, option) => setFieldValue(name, option)}
      onBlur={() => setFieldTouched(name, true)}
      getOptionLabel={v => (v ? v.label : '')}
      openText=""
      closeText=""
      noOptionsText={window.I18n.t('createUser.noCustomOption')}
      renderInput={props => {
        return (
          <MetricaGreenTextField
            {...props}
            {...textFieldProps}
            helperText={helperText}
            error={error}
          />
        )
      }}
    />
  )
}

export default AutocompleteField
